export default __webpack_public_path__ + "static/media/sh_2.0ab1f56d.png";